(function () {
	'use strict';

	angular.module('app.core').config([
		'$stateProvider',
		function ($stateProvider) {
			$stateProvider
				.state('oppor', {
					url: '/:langcode',
					abstract: true,
					templateUrl: 'app/opportunity/views/opportunity.html',
					controller: 'OpportunityController',
					controllerAs: 'vm',
					params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        }
                    },
					resolve: {
						lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
							return lazyLoadSvc.load($transition$, 'opportunity');
						}],

						trans: '$transition$',

						translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
							$translatePartialLoader.addPart('opportunity');
							$translatePartialLoader.addPart('analysis_houseOpportunity');
							return $translate.refresh();
						}]
					}
				})
				.state('oppor.listing', {
					url: '/opportunities/f/:id/:name?portfolio',
					views: {
						main: {
							templateUrl: '/app/opportunity/views/opportunity-listing/opporListing.html',
							controller: 'OpporListingController',
							controllerAs: 'vm'
						},
						// child-views
						'formGeolocation@oppor.listing': {
							templateUrl:
								'/app/opportunity/views/opportunity-listing/opportunityFormGeolocation/opportunityGeolocation.html',
							controller: 'OpportunityGeoController',
							controllerAs: 'vm'
						},
						'formPropertyLand@oppor.listing': {
							templateUrl:
								'/app/opportunity/views/opportunity-listing/opportunityFormPropertyLand/opportunityPropertyLand.html',
							controller: 'OpportunityPropertyLandController',
							controllerAs: 'vm'
						},
						'formPropertyCommercial@oppor.listing': {
							templateUrl: '/app/opportunity/views/opportunity-listing/opportunityFormPropertyCommercial/opportunityPropertyCommercial.html',
							controller: 'OpportunityPropertyCommercialController',
							controllerAs: 'vm'
						},
						'formPropertyResidential@oppor.listing': {
							templateUrl: '/app/opportunity/views/opportunity-listing/opportunityFormPropertyResidential/opportunityFormPropertyResidential.html',
							controller: 'OpportunityPropertyResidentialController',
							controllerAs: 'vm'
						},
						'formValue@oppor.listing': {
							templateUrl:
								'/app/opportunity/views/opportunity-listing/opportunityFormValue/opportunityValue.html',
							controller: 'OpportunityValueController',
							controllerAs: 'vm'
						},
						'formPhoto@oppor.listing': {
							templateUrl:
								'/app/opportunity/views/opportunity-listing/opportunityFormPhoto/opportunityPhoto.html',
							controller: 'OpportunityPhotoController',
							controllerAs: 'vm'
						},
						'formDescription@oppor.listing': {
							templateUrl:
								'/app/opportunity/views/opportunity-listing/opportunityFormDescription/opportunityDescription.html',
							controller: 'OpportunityDescriptionController',
							controllerAs: 'vm'
						},
						'formTitle@oppor.listing': {
							templateUrl:
								'/app/opportunity/views/opportunity-listing/opportunityFormTitle/opportunityTitle.html',
							controller: 'OpportunityTitleController',
							controllerAs: 'vm'
						},
						'formUser@oppor.listing': {
							templateUrl:
								'/app/opportunity/views/opportunity-listing/opportunityFormUser/opportunityUser.html',
							controller: 'OpportunityUserController',
							controllerAs: 'vm'
						},
						'formZoning@oppor.listing': {
							templateUrl:
								'/app/opportunity/views/opportunity-listing/opportunityFormZoning/opportunityZoning.html',
							controller: 'OpportunityZoningController',
							controllerAs: 'vm'
						}
					},
					resolve: {

						trans: '$transition$',

						translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
							$translatePartialLoader.addPart('opportunity');
							return $translate.refresh();
						}]
					},
					params: {
						id: { type: 'any', raw: true },
						name: { type: 'any', raw: true }
					},
					metaTag: {
						robots: 'noindex, nofollow',
						description: '{{descriptionListing}}',
					}
				}).state('publishlisting', {
					url: '/publishlisting?yetkiKodu&durum',
					templateUrl: 'app/opportunity/views/publishlisting.html',
					controller: 'PublishlistingController',
					controllerAs: 'vm',
					params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
						yetkiKodu: { type: 'any', raw: true },
						durum: { type: 'any', raw: true },
                    },
					resolve: {
						lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
							return lazyLoadSvc.load($transition$, 'opportunity');
						}],

						translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
							$translatePartialLoader.addPart('opportunity');
							$translatePartialLoader.addPart('analysis_houseOpportunity');
							return $translate.refresh();
						}]
					}
				});
		}
	]);

})();
